/**
 * 安全解析 Response JSON，避免代理 HTML/纯文本导致 SyntaxError 刷屏
 */

export async function readResponseJsonSafe(res) {
  if (!res) {
    return { ok: false, data: null, text: '', error: new Error('empty-response') };
  }
  let text = '';
  try {
    text = await res.text();
  } catch (error) {
    return { ok: false, data: null, text: '', error };
  }
  if (!text) {
    return { ok: true, data: null, text: '', error: null };
  }
  try {
    return { ok: true, data: JSON.parse(text), text, error: null };
  } catch (error) {
    return { ok: false, data: null, text, error };
  }
}

/** 判断是否为后端/代理不可达类错误（应快速失败，少重试） */
export function isBackendUnavailableError(error, responseText = '') {
  const msg = `${error?.message || error || ''} ${responseText || ''}`;
  return /ECONNREFUSED|Proxy error|Failed to fetch|NetworkError|ERR_CONNECTION|设备列表请求失败 \(HTTP 50[0234]\)|返回非 JSON/i.test(msg);
}

export function getDeviceFetchMaxRetries(error, responseText = '') {
  return isBackendUnavailableError(error, responseText) ? 1 : 3;
}
